import React from 'react'
import styles from './styles.module.css'

const cx = (...c) => c.filter(Boolean).join(' ')

function SideImage({ sideImage, cover }) {
  // task #67: sideImage is a ResolvedImage descriptor; the background url goes inline
  const sideImageUrl = sideImage?.src

  return (
    <div className={styles.sideImageWrapper}>
      <div
        className={cover ? styles.imageCover : cx(styles.imageContained, styles.imageContainedMargins)}
        style={{ backgroundImage: sideImageUrl ? `url(${sideImageUrl})` : undefined }}
      />
    </div>
  )
}

export default SideImage
